import React, { memo } from "react";
import { Button } from "../../Button";
import { FeaturedIcon } from "../../MiscIcons";
import { Modal, ModalHeader, ModalIconBackground, ModalProps } from "../../Modal";
import { useGetMaintenancePeriod } from "../utils";

import { ReactComponent as Maintenance } from "./icons/clock-refresh.svg";

import styles from "./styles.module.scss";

export type MaintenanceModalProps = ModalProps

export const MaintenanceModal = memo<MaintenanceModalProps>(({ ...props }) => {
  return (
    <Modal
      header={
        <ModalHeader
          divider={false}
          text="Scheduled Maintenance Notice"
          align="center"
        >
          <ModalIconBackground type="circle">
            <FeaturedIcon type={"light"} color={"warning"} size={"md"}>
              <Maintenance />
            </FeaturedIcon>
          </ModalIconBackground>
        </ModalHeader>
      }
      divider={false}
      {...props}
    >
      <div className={styles.text}>
        <b>Please be advised:</b>
        <br />
        Our system will undergo <b>scheduled maintenance</b> on:
        <br />
        <br />
        <b>🗓️ {useGetMaintenancePeriod()}</b>
        <br />
        <br />
        During this time, <b>the portal will be temporarily unavailable.</b>
        This maintenance is essential to ensure continued performance and security improvements.
        <br />
        <br />
        We apologize for any inconvenience and appreciate your patience.
        If you have any questions, please contact us at
        <Button 
          className={styles.mail}
          component={"a"} 
          href="mailTo:support@tecorien.com" 
          buttonType="linkColor" 
          buttonSize="lg"
        >
          support@tecorien.com.
        </Button>
      </div>
    </Modal>
  );
});